import { dialogComponentModule } from '../../dialog/dialog';

export const formDataComponentModule = angular
  .module('Q.components.forms.form-data', [dialogComponentModule])

  .factory(
    'formDataRestorePrompt',
    function (dialogService, $q, $state, $rootScope) {
      return {
        prompt(fd, item = 'this item') {
          return $q
            .when(fd.hasCache())
            .then((cache) => {
              if ((cache && !$state.current) || !$state.current.name) {
                return $q((resolve) => {
                  const unlisten = $rootScope.$on('$stateChangeSuccess', () => {
                    unlisten();
                    resolve(cache);
                  });
                });
              }
              return cache;
            })
            .then((cache) => {
              return (
                cache &&
                dialogService.confirm(
                  `<p>Looks like you have some changes that didn't get saved for ${item}.</p><p>Would you like to restore those changes?</p>`,
                )
              );
            })
            .then(
              (resp) => {
                let restore = !!resp && resp.id === 'yes';
                if (restore) {
                  fd.restoreCache();
                }
                return restore;
              },
              () => false,
            );
        },
      };
    },
  )

  .directive('formData', function () {
    return {
      restrict: 'A',
      require: ['^form', 'formData'],
      controller() {},
      link(scope, elem, attrs, [ngForm, formData]) {
        let fd = scope.$eval(attrs.formData);

        formData.fd = fd;

        fd.initForm(scope, ngForm);
      },
    };
  });
